import { render } from "./ChipsFiat.vue?vue&type=template&id=f740d6b2&scoped=true"
import script from "./ChipsFiat.vue?vue&type=script&lang=js"
export * from "./ChipsFiat.vue?vue&type=script&lang=js"

import "./ChipsFiat.vue?vue&type=style&index=0&id=f740d6b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f740d6b2"]])

export default __exports__